import { render, staticRenderFns } from "./type-aanvraag.vue?vue&type=template&id=b92b2ce2"
import script from "./type-aanvraag.vue?vue&type=script&lang=js"
export * from "./type-aanvraag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports